export default __webpack_public_path__ + "static/media/Fairmont-jaipur-slider.1656d979.jpg";